// Test IDs for the Emerging Risk Lab Pathway insurance mode.
export const PATHWAY = {
  // Top navigation
  navWordmark: "nav-wordmark",
  navMission: "nav-mission",
  navGovernanceCentre: "nav-governance-centre",
  navWorkflow: "nav-workflow",
  navBoundaries: "nav-boundaries",
  navJourney: "nav-journey",
  navThemes: "nav-themes",
  navScenario: "nav-scenario",
  navOutputs: "nav-outputs",
  navAdoption: "nav-adoption",
  navIntake: "nav-intake",
  navSponsorCta: "nav-sponsor-cta",

  // Hero
  heroTitle: "hero-title",
  heroSubtitle: "hero-subtitle",
  heroSponsorCta: "hero-sponsor-cta",
  heroExploreCta: "hero-explore-cta",

  // Disclaimer banner
  disclaimerBanner: "disclaimer-banner",

  // Positioning strip (persistent under nav)
  positioningStrip: "positioning-strip",

  // Operational Mission (under hero)
  missionPanel: "mission-panel",
  missionObjective: "mission-objective",
  missionPilot: "mission-pilot",
  missionOutcome: (i) => `mission-outcome-${i}`,
  missionStage: "mission-stage",

  // Operational Governance Centre (renamed from Control Centre)
  governanceCentre: "governance-centre",
  controlTile: (slug) => `governance-tile-${slug}`,

  // Platform Boundaries
  boundariesDiagram: "boundaries-diagram",
  boundaryNode: (slug) => `boundary-node-${slug}`,

  // Operational Debt
  operationalDebt: "operational-debt",
  debtState: (slug) => `debt-state-${slug}`,
  debtBar: (state, slug) => `debt-bar-${state}-${slug}`,

  // Operational confidence (alongside scenario)
  confidenceCard: "confidence-card",
  confidenceItem: (slug) => `confidence-item-${slug}`,

  // Workflow diagram (Broker → … → KATLAS → … → Claims)
  workflowDiagram: "workflow-diagram",
  workflowPre: (i) => `workflow-pre-${i}`,
  workflowPost: (i) => `workflow-post-${i}`,
  workflowKatlas: "workflow-katlas",
  workflowFacet: (slug) => `workflow-facet-${slug}`,

  // What KATLAS governs
  governsDiagram: "governs-diagram",
  governsUpstream: (i) => `governs-upstream-${i}`,
  governsDownstream: (i) => `governs-downstream-${i}`,

  // Architecture hierarchy
  architectureDiagram: "architecture-diagram",

  // Journey
  journeyStep: (i) => `journey-step-${i}`,

  // Themes
  themeCard: (slug) => `theme-card-${slug}`,
  themeSelected: "theme-selected",

  // Reference scenario
  exceptionLoop: "exception-loop",
  exceptionLoopStep: (i) => `exception-loop-step-${i}`,
  governanceState: "governance-state",
  governanceFacet: (slug) => `governance-facet-${slug}`,
  scenarioWalkthroughStep: (i) => `scenario-walkthrough-step-${i}`,
  scenarioGenerateReceipt: "scenario-generate-receipt",

  // Cyber referral sample
  cyberSampleCard: "cyber-sample-card",
  cyberSampleGenerate: "cyber-sample-generate",

  // Receipt modal
  receiptModal: "receipt-modal",
  receiptVerificationState: "receipt-verification-state",
  receiptTabReceipt: "receipt-tab-receipt",
  receiptTabTimeline: "receipt-tab-timeline",
  receiptViewApi: "receipt-view-api",
  receiptDownloadJson: "receipt-download-json",
  receiptApiPanel: "receipt-api-panel",
  receiptTimelinePanel: "receipt-timeline-panel",
  receiptTimelineEvent: (i) => `receipt-timeline-event-${i}`,
  receiptExplainButton: "receipt-explain-button",
  receiptExplainPanel: "receipt-explain-panel",
  receiptClose: "receipt-close",

  // Thought leadership
  thoughtLeadershipPanel: "thought-leadership-panel",

  // Lab outputs
  labOutputsList: "lab-outputs-list",

  // Adoption path (replaces sponsor packages)
  adoptionStage: (slug) => `adoption-stage-${slug}`,

  // Sponsor intake form
  intakeForm: "intake-form",
  intakeName: "intake-name",
  intakeOrganisation: "intake-organisation",
  intakeEmail: "intake-email",
  intakeLine: "intake-line",
  intakeAudience: (slug) => `intake-audience-${slug}`,
  intakeOutput: (slug) => `intake-output-${slug}`,
  intakeBudget: "intake-budget",
  intakeNotes: "intake-notes",
  intakeSubmit: "intake-submit",
  intakeConfirmation: "intake-confirmation",
  intakeReference: "intake-reference",
  intakeReceiptDownload: "intake-receipt-download",
  intakeReset: "intake-reset",

  // Footer
  footer: "footer",

  // Runtime status (KATLAS runtime gateway)
  runtimeIndicator: "runtime-indicator",
  runtimeIndicatorToggle: "runtime-indicator-toggle",
  runtimeIndicatorPanel: "runtime-indicator-panel",
  runtimeStatusPanel: "runtime-status-panel",
  runtimeField: (slug) => `runtime-field-${slug}`,
};
